import { useEffect, useState, useCallback, useRef } from "react";

/** Powers one independent Monthly Record section (Schedule/Availability/Reconciliation/
 * Payroll/etc). Each section fetches on its own - a slow or failing section (permission
 * denied, 404, network error) never blocks the others from rendering (see MonthlyRecordTab). */
export function usePeriodSection(fetchFn, deps, { enabled = true } = {}) {
  const [state, setState] = useState({ data: null, loading: enabled, error: null });
  const requestId = useRef(0);

  const load = useCallback(() => {
    if (!enabled) {
      setState({ data: null, loading: false, error: null });
      return;
    }
    const thisRequest = ++requestId.current;
    setState((prev) => ({ ...prev, loading: true, error: null }));
    fetchFn()
      .then((res) => {
        if (thisRequest === requestId.current) setState({ data: res.data, loading: false, error: null });
      })
      .catch((err) => {
        if (thisRequest === requestId.current) {
          setState({
            data: null, loading: false,
            error: {
              status: err.response?.status || null,
              message: err.response?.data?.detail || "Something went wrong loading this section.",
            },
          });
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  useEffect(() => { load(); }, [load]);

  return { ...state, retry: load };
}
